import { 
    Box,
    Container,
    Stack,
} from '@mui/material';

import Logo from '../Logo';

const PageLogo = () => {
    return (
        <Box
            className='page-header'
            sx={{}}
        >
            <Container
                className='padding-on-mobile'
            >
                <Stack
                    justifyContent='center'
                    alignItems='center'
                    sx={{
                        mt: 8,
                        mb: 4,
                    }}
                >
                    <Logo />
                </Stack>
            </Container>
        </Box>
    )
};

export default PageLogo;